import Toast from './Toast.vue'

export default {
	install (Vue, options) {
		const VueToast = Vue.extend(Toast)
		let instance = null
		let getToastInstance = () => {
			if (instance) {
				return instance
			}
			return new VueToast({
				el: document.createElement('div')
			})
		}
		VueToast.prototype.close = function () {
			this.visible = false
			this.closed = true
		}
		let $Toast = (options = {}) => {
			return new Promise((resolve) => {
				let duration = options.duration || 2000
				duration = duration > 10000 ? 10000 : duration
				instance = getToastInstance()
				instance.closed = false
				clearTimeout(instance.timer)
				instance.message = typeof options === 'string' ? options : options.message
				instance.type = options.type || 'success'
				document.body.appendChild(instance.$el)
				Vue.nextTick(function () {
					instance.visible = true
					~duration && (instance.timer = setTimeout(function () {
						if (instance.closed) return
						instance.close()
						resolve()
					}, duration))
				})
				return instance
			})
		}
		$Toast.getVisiable = function () {
			return instance && instance.closed === false
		}
		const createParams = function (type, msg) {
			let params = {
				type,
				message: '',
				duration: 1500
			}
			if (typeof msg === 'string') {
				params.message = msg
			} else if (Object.prototype.toString.call(msg) === '[object Object]') {
				params = Object.assign(params, msg)
				params.type = type
			}
			return params
		}
		$Toast.success = function (msg) {
			return $Toast(createParams('success', msg))
		}
		$Toast.warning = function (msg) {
			return $Toast(createParams('warning', msg))
		}
		$Toast.fail = function (msg) {
			return $Toast(createParams('fail', msg))
		}
		$Toast.netError = function (msg) {
			return $Toast(createParams('netError', msg))
		}
		Vue.prototype.$fxToast = $Toast
	}
}



// WEBPACK FOOTER //
// ./src/lib/wind-ui/package/toast/index.js